import { Box } from "@nulogy/components";
import React from "react";

export default function NotFoundView() {
  return <Box>Page not found</Box>;
}
